import React, { Component } from "react";
import PropTypes from "prop-types";
import { SvgLoader, SvgProxy } from "react-svgmt";
import { ImagenEco } from "./ImageContext";
import { connect } from "react-redux"; 	
import { terminaRecorrido} from "../js/actions/index";
import {estructurasTxt} from "../caso";
import "./ecografia.scss";

const mapStateToProps = state => {
	return { anatomia: state.anatomia };
};

const mapDispatchToProps = dispatch => {
	return{
		terminaRecorrido: () => dispatch(terminaRecorrido()),
	};
};

class EcografiaConected extends Component {
	static contextType = ImagenEco;
	static propTypes = {
		anatomia:PropTypes.object,
		terminaRecorrido:PropTypes.func,
	}
	state = {
		atlasVisible:false,
		atlas:[],
		estructuraOver:"",
		completados:0,
		recorridoActual:-1,
	}
	handleOverStruct = (element,numAtlas) => {
		let id = element.id.replace(/_\d_/,"").toLowerCase();
		if(id.endsWith("linea")) id = id.substring(0,id.length - 5);
		if(!this.state.atlas[numAtlas].encontradas.includes(id)){
			let item = this.state.atlas[numAtlas].estructuras[id];
			if(item)
				item.forEach((struct)=> struct.classList.add("found"));
			else
				alert("No encontrado "+id);
			let newEncontradas = this.state.atlas[numAtlas].encontradas.concat([id]);
			let newState = {...this.state};
			newState.atlas[numAtlas].encontradas = newEncontradas;
			newState.estructuraOver = id;
			this.setState(newState);
		}else{
			this.setState({estructuraOver:id});
		}
		let completados = 0;
		let terminado = true;
		if(this.props.anatomia.recorridoActual >= 0 && this.props.anatomia.recorridoActual < this.props.anatomia.recorridos.length){
			let recorrido = this.props.anatomia.recorridos[this.props.anatomia.recorridoActual];
			if(recorrido.atlas){
				for(let numAtlas = 0; numAtlas < recorrido.atlas.length; numAtlas ++){
					if(!this.state.atlas[numAtlas])
						terminado = false;
					else {
						let terminadoAtlas = true;
						for(let index in this.state.atlas[numAtlas].estructuras) 
							if(!this.state.atlas[numAtlas].encontradas.includes(index))terminadoAtlas = false;
						if(terminadoAtlas) completados++;
						else terminado = false;
					}
				}
			}
		}
		if(terminado) this.props.terminaRecorrido();
		if(completados > this.state.completados ) this.setState({completados:completados});
	}
	atlasVisible= ()=>{
		this.setState({atlasVisible:true});
	}
	render(){
		let image = null;
		let numImage = 0;
		let distanciaAtlas = 10;
		let atlasSVG = null;
		let totalAtlas = 0;
		let AtlasActual = -1;
		let numEstructuras = 0;
		if(this.props.anatomia.recorridoActual !== this.state.recorridoActual){
			this.setState({
				atlasVisible:false,
				atlas:[],
				estructuraOver:"",
				completados:0,
				recorridoActual:this.props.anatomia.recorridoActual,
			});

		}
		if(this.context.eco.length > 0 && this.props.anatomia.recorridoActual >= 0 && this.props.anatomia.recorridoActual < this.props.anatomia.recorridos.length){
			let recorrido = this.props.anatomia.recorridos[this.props.anatomia.recorridoActual];
			if(!this.props.anatomia.terminado && (!recorrido.atlas || recorrido.atlas.length === 0))
				this.props.terminaRecorrido();
			numImage = Math.round(recorrido.iniImg + (recorrido.finImg - recorrido.iniImg)*this.props.anatomia.porcentaje);
			if(recorrido.atlas){
				totalAtlas = recorrido.atlas.length;
				let EnAtlas = false;
				for(let numAtlas = 0; numAtlas < recorrido.atlas.length; numAtlas++){
					let atlas = recorrido.atlas[numAtlas];
					if(Math.abs(atlas.pos-numImage) < distanciaAtlas){ 
						distanciaAtlas = Math.abs(atlas.pos - numImage); 
					}
					if(Math.abs(atlas.pos - numImage) < 2 && this.state.atlasVisible){
						EnAtlas = true;
						AtlasActual = numAtlas;
						let structs = [];
						if(this.state.atlas[numAtlas] && this.state.atlas[numAtlas].estructuras)for(let index in this.state.atlas[numAtlas].estructuras){
							let clase = "";
							if(this.state.atlas[numAtlas].encontradas.includes(index))
								clase = "active";
							if(this.state.estructuraOver === index)
								clase += " on";
							let texto=(index in estructurasTxt)?estructurasTxt[index]:"["+index+"]";
							structs.push(<div key={index} className={clase} id={"struct_"+index} onMouseOver={()=>{this.setState({estructuraOver:index});}}>{texto}</div>);
						}
						atlasSVG = <>
							<header id="structs">
								{structs}
							</header>
							<div id="atlas">
								<SvgLoader path={"content/eco/"+atlas.atlas}>
									<SvgProxy selector="svg" height="100%"/>
									<SvgProxy selector="image" onElementSelected={(node) => {
										let nombre = node.attributes["xlink:href"].value;
										if(nombre.indexOf("/") === -1){
											node.attributes["xlink:href"].value = "content/eco/"+atlas.atlas.substring(0,atlas.atlas.lastIndexOf("/"))+"/"+nombre;
										}
									}}/>
									<SvgProxy selector="path" onElementSelected={ (node)=>{ 
										let newState = {...this.state};
										if(!newState.atlas[numAtlas]) {
											let estructuras = [];
											node.forEach((element)=>{
												let id = element.id.replace(/_\d_/,"").toLowerCase();
												if(id.endsWith("linea")) id = id.substring(0,id.length - 5);
												if(!estructuras[id])estructuras[id] = [];
												estructuras[id].push(element);
												if(!element.id.endsWith("Linea")){
													element.addEventListener("mouseover",() => {this.handleOverStruct(element,numAtlas); });
												}
											});
											newState.atlas[numAtlas] = {estructuras:estructuras,encontradas:[]};
											this.setState(newState);
										}else node.forEach((element)=>{
											let id = element.id.replace(/_\d_/,"").toLowerCase();
											if(id.endsWith("linea")) id = id.substring(0,id.length - 5);
											if(!element.id.endsWith("Linea"))
												element.addEventListener("mouseover",() => {this.handleOverStruct(element,numAtlas); });
											if(newState.atlas[numAtlas].encontradas.includes(id)) element.classList.add("found");
										});
									}} 
									/>
								</SvgLoader>
							</div>
						</>;
						if(this.state.atlas[numAtlas] && this.state.atlas[numAtlas].estructuras)
							for( var index in this.state.atlas[numAtlas].estructuras){
								numEstructuras ++;
								let item = this.state.atlas[numAtlas].estructuras[index];
								if(index === this.state.estructuraOver)
									item.forEach((struct) => struct.classList.add("on"));
								else item.forEach((struct) => struct.classList.remove("on"));
							}
					}
				}
				if(!EnAtlas && this.state.atlasVisible)this.setState({atlasVisible:false});
			}
			image = this.context.eco[numImage];
		}else{
			numImage = Math.floor(Math.random()*this.context.ruido.length);
			image = this.context.ruido[numImage];
			numImage = -1*numImage;
		}
		let clase = "semaforoAtlas";
		if(distanciaAtlas < 2) clase += " on";
		let color = Math.round((10-distanciaAtlas)/10*200)+55;
		let estilo = {color:"rgb("+color+","+color+","+color+")"};
		if(totalAtlas === 0) estilo["display"]="none";
		let divEstructuras = null;
		if(AtlasActual > -1 && this.state.atlas[AtlasActual])
			divEstructuras = <div className="numEstructuras">Estructuras {this.state.atlas[AtlasActual].encontradas.length}/{numEstructuras}</div>;
		return(
			<section id="ecografía">
				{divEstructuras}
				<div className={clase} style={estilo} onClick={()=>{if(distanciaAtlas < 2)this.atlasVisible();}}>Atlas ({this.state.completados+"/"+totalAtlas})</div>
				<img id="imagenEco" alt="" src={(image)?image.src:""} ref={node => {this.container = node;}}></img>
				<div id="divAtlas">{atlasSVG}</div>
				<footer id="pieEco">
				</footer>
			</section>
		);
	}
}

const Ecografia = connect(mapStateToProps,mapDispatchToProps)(EcografiaConected);
export default Ecografia;